<template>
<div class="chapter">
<div class="inner_page">
<h3 class="chap-title"><a id="page_5"></a><span class="bold">Acknowledgements</span></h3>
<p class="noindent">Paul Ainsworth for his constant support and encouragement</p>
<p class="noindent">Jeff Chambers, Michael Chance, Paul Darlow, Tony Heald, Ken Keen,</p>
<p class="indent">Dan Parker, Doreen Piper, Brian Rowe, Peter Shield, Steven Skelley,</p>
<p class="indent">Chris Skidmore, Paul Stebbing, Steve Wyatt</p>
<p class="noindent">Barnsley Archives, Derbyshire Archives, BMBC Bereavement Services</p>
<p class="noindent">National Coalmining Museum, National Union of Mineworkers</p>
<p class="noindent">The <em class="italic">Barnsley Chronicle</em> digitised newspapers, the Tasker Trust</p>
<div class="img_container"><img alt="images" src="images/f0005-01.jpg"/>
<p class="caption">Interpretation of the Oaks explosion by Darren Green (AKA L. Gold).</p>
</div>
<h4 class="sub_level"><a id="page_6"></a><span class="bold">Websites</span></h4>
<p class="hang">Ancestry, FindMyPast*, the Genealogist – subscriptions (* newspapers)</p>
<p class="hang">FreeBMD, GRO.gov, gov.uk/search-will-probate, cemeteries.org.uk, find a grave</p>
<p class="hang">TaskerTrust.co.uk</p>
<p class="hang">Durham Mining Museum, healeyhero.co.uk,</p>
<p class="hang">DVLP website for Oaks 1866 victims</p>
<p class="hang">Dearne Memorials Group database, Ardsley Residents Association website</p>
<p class="hang">Peter Higginbotham’s workhouses.org.uk</p>
<p class="hang">Measuringworth.com</p>
<p class="hang">Visionofbritain.org.uk</p>
<p class="hang">Wikipedia and many general searches for background information</p>
<h4 class="sub_level"><span class="bold">Photographs</span></h4>
<p class="noindent1a">Front Cover - “Head to Face” was embroidered by Maureen Livesey and purchased by the Author</p>
<p class="noindent1a">Back Cover - both drawings of the Oaks Colliery explosion 1847 were produced for the <em class="italic">Illustrated London News</em> (Barnsley Archives)</p>
<p class="noindent1a">Where the copyright of a photograph is not indicated it is the property of the Author and may not be used without permission</p>
<div class="img_container"><img alt="images" src="images/f0006-01.jpg"/>
<p class="caption">Ledger record of the Annual Meeting 1849. (© Barnsley Archives)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Chapter02.vue?415a693c